/**
 * Content Registry - Maps URL slugs to content components.
 *
 * Slugs match the navigation structure in navigation.ts:
 * - Getting Started (beta onboarding)
 * - What is Compounds?
 * - How to Use Compounds
 * - Workflow Reference
 * - Troubleshooting
 */

import { type ComponentType, lazy } from 'react';

const GettingStartedBeta = lazy(() =>
  import('./getting-started-beta').then(m => ({ default: m.GettingStartedBeta })),
);
const ProductCreatorSetup = lazy(() =>
  import('./product-creator-setup').then(m => ({ default: m.ProductCreatorSetup })),
);
const WhatIsCompounds = lazy(() =>
  import('./what-is-compounds').then(m => ({ default: m.WhatIsCompounds })),
);
const HowToUse = lazy(() => import('./getting-started').then(m => ({ default: m.GettingStarted })));
const Reference = lazy(() => import('./reference').then(m => ({ default: m.Reference })));
const Troubleshooting = lazy(() =>
  import('./troubleshooting').then(m => ({ default: m.Troubleshooting })),
);

/**
 * Map of URL slug to content component.
 * The slug is the path segment after /docs/ (e.g., /docs/getting-started)
 */
export const contentRegistry: Record<string, ComponentType> = {
  'getting-started': GettingStartedBeta,
  'how-to-use': HowToUse,
  'product-creator-setup': ProductCreatorSetup,
  'what-is-compounds': WhatIsCompounds,
  reference: Reference,
  troubleshooting: Troubleshooting,
};

/**
 * Get the content component for a given slug.
 * Returns undefined if slug is not found.
 */
export function getContentComponent(slug: string): ComponentType | undefined {
  return contentRegistry[slug];
}

/**
 * Check if a slug has registered content.
 */
export function hasContent(slug: string): boolean {
  return slug in contentRegistry;
}
